export enum PagePanelColors {
    DEFAULT = 'default',
    ACCENT = 'accent',
    INFO = 'info',
    WARNING = 'warning',
}
